var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3573_31361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.29791 7.19922C3.58278 7.19922 2.99768 7.78432 2.99768 8.49945C2.99768 9.21458 3.58278 9.79968 4.29791 9.79968C5.01304 9.79968 5.59814 9.21458 5.59814 8.49945C5.59814 7.78432 5.01304 7.19922 4.29791 7.19922ZM12.0993 7.19922C11.3842 7.19922 10.7991 7.78432 10.7991 8.49945C10.7991 9.21458 11.3842 9.79968 12.0993 9.79968C12.8144 9.79968 13.3995 9.21458 13.3995 8.49945C13.3995 7.78432 12.8144 7.19922 12.0993 7.19922ZM8.1986 7.19922C7.48348 7.19922 6.89837 7.78432 6.89837 8.49945C6.89837 9.21458 7.48348 9.79968 8.1986 9.79968C8.91373 9.79968 9.49883 9.21458 9.49883 8.49945C9.49883 7.78432 8.91373 7.19922 8.1986 7.19922Z",
    fill: "#65676B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3573_31361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.6028,
    height: 15.6028,
    fill: "white",
    transform: "translate(0.397217 0.698242)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/threeDots.0be8dc6e.svg";
export { ForwardRef as ReactComponent };